import { useCallback, useState } from 'react';
import { EntitlementsProject } from '@adsk/alloy-provider';
import { DEFAULT_SORT_FIELD, TABLE_SORT_DIRECTION } from '../constants';

export type PageState = {
  sortDirection: TABLE_SORT_DIRECTION;
  sortKey: keyof EntitlementsProject;
  searchString: string;
  offset: number;
  searchChangeHandler: (value: string) => void;
  sortChangeHandler: (
    sortKey: keyof EntitlementsProject,
    sortDirection: TABLE_SORT_DIRECTION
  ) => void;
  pageChangeHandler: (offset: number) => void;
};

export const usePageState = (): PageState => {
  // Configure and manage pageState
  const [pageState, setPageState] = useState<
    Pick<PageState, 'sortDirection' | 'sortKey' | 'searchString' | 'offset'>
  >({
    sortDirection: TABLE_SORT_DIRECTION.DESCENDING,
    sortKey: DEFAULT_SORT_FIELD,
    searchString: '',
    offset: 0,
  });

  // Create handlers to modify pageState
  const searchChangeHandler = useCallback(
    (value: string) => {
      setPageState((prevState) => ({
        ...prevState,
        searchString: value,
        offset: 0,
      }));
    },
    [setPageState]
  );

  const pageChangeHandler = useCallback(
    (offset: number) => {
      setPageState((prevState) => ({
        ...prevState,
        offset,
      }));
    },
    [setPageState]
  );

  const sortChangeHandler = useCallback(
    (
      sortKey: keyof EntitlementsProject,
      sortDirection: TABLE_SORT_DIRECTION
    ) => {
      setPageState((prevState) => ({
        ...prevState,
        sortDirection,
        sortKey,
        offset: 0,
      }));
    },
    [setPageState]
  );

  // Return relevant data to the consumer
  return {
    ...pageState,
    searchChangeHandler,
    sortChangeHandler,
    pageChangeHandler,
  };
};
